module.exports = __webpack_public_path__ + "static/media/Poppins-Bold.08c20a48.ttf";